import type { FilterDefaultsHandle } from './useFilterDefaults.js';

/**
 * Compact "Save filters as my default" / "Clear saved" pair, rendered next to a page's
 * filter controls. Wire `onSave` to capture the page's CURRENT filter state.
 */
export function FilterDefaultsButtons({
  handle,
  onSave,
}: {
  handle: FilterDefaultsHandle;
  onSave: () => void;
}): JSX.Element {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onSave}
        disabled={handle.isSaving}
        title="Save the current filters as my default for this page"
        className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-600 hover:bg-slate-50 disabled:opacity-50"
      >
        {handle.isSaving ? 'Saving…' : 'Save filters'}
      </button>
      {handle.hasSaved ? (
        <button
          type="button"
          onClick={() => handle.clear()}
          disabled={handle.isSaving}
          title="Remove my saved default filters for this page"
          className="rounded-lg px-2 py-2 text-xs font-medium text-slate-500 hover:text-slate-700 disabled:opacity-50"
        >
          Clear saved
        </button>
      ) : null}
    </div>
  );
}
